import axios from "axios";
import { cacheClear } from "./apiCache";
import { tokens } from "../auth/tokens";

/**
 * Tiện ích cookie/localStorage dùng chung (không riêng gì phiên đăng nhập).
 * Riêng các khóa của phiên (`access_token`, `type_user`, `permissions`, cache menu)
 * do `auth/tokens.js` sở hữu — đừng xóa tay ở đây, gọi `tokens.clear()`.
 */
export const settings = {
  setStorageJson: (name, data) => {
    data = JSON.stringify(data);
    localStorage.setItem(name, data);
  },
  setStorage: (name, data) => {
    localStorage.setItem(name, data);
  },
  getStorageJson: (name) => {
    if (localStorage.getItem(name)) {
      const data = JSON.parse(localStorage.getItem(name));
      return data;
    }
    return; //undefined
  },
  getStore: (name) => {
    if (localStorage.getItem(name)) {
      const data = localStorage.getItem(name);
      return data;
    }
    return; //undefined
  },
  setCookieJson: (name, value, days) => {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    value = JSON.stringify(value);
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  getCookieJson: (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return JSON.parse(c.substring(nameEQ.length, c.length));
    }
    return null;
  },
  setCookie: (name, value, days) => {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  delete_cookie: (name) => {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  },
  getCookie: (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  eraseCookie: (name) => {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  },
};
export const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL, //tất cả các hàm khi gọi api đều sử dụng domain này
  timeout: 20000,
});
// Request: gắn token vào mọi lời gọi.
http.interceptors.request.use(
  (config) => {
    const token = tokens.accessToken();
    if (token) {
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
  },
  (err) => Promise.reject(err)
);

/**
 * Response: 401 nghĩa là phiên hết hẳn -> xóa sạch rồi về trang đăng nhập.
 *
 * `tokens.clear()` phát tín hiệu cho `auth/session.js` tự reset store, nên ở đây
 * không phải liệt kê từng khóa localStorage như trước (danh sách đó từng bị lệch
 * giữa interceptor và hàm logout).
 */
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      tokens.clear();
      cacheClear();
      // Đang ở /login rồi thì đừng nhảy nữa — sai mật khẩu cũng trả 401 và việc
      // reload sẽ xóa mất câu thông báo lỗi vừa hiện.
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);
